const sabaths = [
  {
    key: "Lección 1",
    text: "Lección 1",
    value: "2025-10-04",
    quarter: "2025Q4"
  },
  {
    key: "Lección 2",
    text: "Lección 2",
    value: "2025-10-11",
    quarter: "2025Q4"
  },
  {
    key: "Lección 3",
    text: "Lección 3",
    value: "2025-10-18",
    quarter: "2025Q4"
  },
  {
    key: "Lección 4",
    text: "Lección 4",
    value: "2025-10-25",
    quarter: "2025Q4"
  },
  {
    key: "Lección 5",
    text: "Lección 5",
    value: "2025-11-01",
    quarter: "2025Q4"
  },
  {
    key: "Lección 6",
    text: "Lección 6",
    value: "2025-11-08",
    quarter: "2025Q4"
  },
  {
    key: "Lección 7",
    text: "Lección 7",
    value: "2025-11-15",
    quarter: "2025Q4"
  },
  {
    key: "Lección 8",
    text: "Lección 8",
    value: "2025-11-22",
    quarter: "2025Q4"
  },
  {
    key: "Lección 9",
    text: "Lección 9",
    value: "2025-11-29",
    quarter: "2025Q4"
  },
  {
    key: "Lección 10",
    text: "Lección 10",
    value: "2025-12-06",
    quarter: "2025Q4"
  },
  {
    key: "Lección 11",
    text: "Lección 11",
    value: "2025-12-13",
    quarter: "2025Q4"
  },
  {
    key: "Lección 12",
    text: "Lección 12",
    value: "2025-12-20",
    quarter: "2025Q4"
  },
  {
    key: "Lección 13",
    text: "Lección 13",
    value: "2025-12-27",
    quarter: "2025Q4"
  },
  {
    key: "Lección 1",
    text: "Lección 1",
    value: "2026-01-03",
    quarter: "2026Q1"
  },
  {
    key: "Lección 2",
    text: "Lección 2",
    value: "2026-01-10",
    quarter: "2026Q1"
  },
  {
    key: "Lección 3",
    text: "Lección 3",
    value: "2026-01-17",
    quarter: "2026Q1"
  },
  {
    key: "Lección 4",
    text: "Lección 4",
    value: "2026-01-24",
    quarter: "2026Q1"
  },
  {
    key: "Lección 5",
    text: "Lección 5",
    value: "2026-01-31",
    quarter: "2026Q1"
  },
  {
    key: "Lección 6",
    text: "Lección 6",
    value: "2026-02-07",
    quarter: "2026Q1"
  },
  {
    key: "Lección 7",
    text: "Lección 7",
    value: "2026-02-14",
    quarter: "2026Q1"
  },
  {
    key: "Lección 8",
    text: "Lección 8",
    value: "2026-02-21",
    quarter: "2026Q1"
  },
  {
    key: "Lección 9",
    text: "Lección 9",
    value: "2026-02-28",
    quarter: "2026Q1"
  },
  {
    key: "Lección 10",
    text: "Lección 10",
    value: "2026-03-07",
    quarter: "2026Q1"
  },
  {
    key: "Lección 11",
    text: "Lección 11",
    value: "2026-03-14",
    quarter: "2026Q1"
  },
  {
    key: "Lección 12",
    text: "Lección 12",
    value: "2026-03-21",
    quarter: "2026Q1"
  },
  {
    key: "Lección 13",
    text: "Lección 13",
    value: "2026-03-28",
    quarter: "2026Q1"
  },
  {
    key: "Lección 1",
    text: "Lección 1",
    value: "2026-04-04",
    quarter: "2026Q2"
  },
  {
    key: "Lección 2",
    text: "Lección 2",
    value: "2026-04-11",
    quarter: "2026Q2"
  },
  {
    key: "Lección 3",
    text: "Lección 3",
    value: "2026-04-18",
    quarter: "2026Q2"
  },
  {
    key: "Lección 4",
    text: "Lección 4",
    value: "2026-04-25",
    quarter: "2026Q2"
  },
  {
    key: "Lección 5",
    text: "Lección 5",
    value: "2026-05-02",
    quarter: "2026Q2"
  },
  {
    key: "Lección 6",
    text: "Lección 6",
    value: "2026-05-09",
    quarter: "2026Q2"
  },
  {
    key: "Lección 7",
    text: "Lección 7",
    value: "2026-05-16",
    quarter: "2026Q2"
  },
  {
    key: "Lección 8",
    text: "Lección 8",
    value: "2026-05-23",
    quarter: "2026Q2"
  },
  {
    key: "Lección 9",
    text: "Lección 9",
    value: "2026-05-30",
    quarter: "2026Q2"
  },
  {
    key: "Lección 10",
    text: "Lección 10",
    value: "2026-06-06",
    quarter: "2026Q2"
  },
  {
    key: "Lección 11",
    text: "Lección 11",
    value: "2026-06-13",
    quarter: "2026Q2"
  },
  {
    key: "Lección 12",
    text: "Lección 12",
    value: "2026-06-20",
    quarter: "2026Q2"
  },
  {
    key: "Lección 13",
    text: "Lección 13",
    value: "2026-06-27",
    quarter: "2026Q2"
  },
  {
    key: "Lección 1",
    text: "Lección 1",
    value: "2026-07-04",
    quarter: "2026Q3"
  },
  {
    key: "Lección 2",
    text: "Lección 2",
    value: "2026-07-11",
    quarter: "2026Q3"
  },
  {
    key: "Lección 3",
    text: "Lección 3",
    value: "2026-07-18",
    quarter: "2026Q3"
  },
  {
    key: "Lección 4",
    text: "Lección 4",
    value: "2026-07-25",
    quarter: "2026Q3"
  },
  {
    key: "Lección 5",
    text: "Lección 5",
    value: "2026-08-01",
    quarter: "2026Q3"
  },
  {
    key: "Lección 6",
    text: "Lección 6",
    value: "2026-08-08",
    quarter: "2026Q3"
  },
  {
    key: "Lección 7",
    text: "Lección 7",
    value: "2026-08-15",
    quarter: "2026Q3"
  },
  {
    key: "Lección 8",
    text: "Lección 8",
    value: "2026-08-22",
    quarter: "2026Q3"
  },
  {
    key: "Lección 9",
    text: "Lección 9",
    value: "2026-08-29",
    quarter: "2026Q3"
  },
  {
    key: "Lección 10",
    text: "Lección 10",
    value: "2026-09-05",
    quarter: "2026Q3"
  },
  {
    key: "Lección 11",
    text: "Lección 11",
    value: "2026-09-12",
    quarter: "2026Q3"
  },
  {
    key: "Lección 12",
    text: "Lección 12",
    value: "2026-09-19",
    quarter: "2026Q3"
  },
  {
    key: "Lección 13",
    text: "Lección 13",
    value: "2026-09-26",
    quarter: "2026Q3"
  },
  {
    key: "Lección 1",
    text: "Lección 1",
    value: "2026-10-03",
    quarter: "2026Q4"
  },
  {
    key: "Lección 2",
    text: "Lección 2",
    value: "2026-10-10",
    quarter: "2026Q4"
  },
  {
    key: "Lección 3",
    text: "Lección 3",
    value: "2026-10-17",
    quarter: "2026Q4"
  },
  {
    key: "Lección 4",
    text: "Lección 4",
    value: "2026-10-24",
    quarter: "2026Q4"
  },
  {
    key: "Lección 5",
    text: "Lección 5",
    value: "2026-10-31",
    quarter: "2026Q4"
  },
  {
    key: "Lección 6",
    text: "Lección 6",
    value: "2026-11-07",
    quarter: "2026Q4"
  },
  {
    key: "Lección 7",
    text: "Lección 7",
    value: "2026-11-14",
    quarter: "2026Q4"
  },
  {
    key: "Lección 8",
    text: "Lección 8",
    value: "2026-11-21",
    quarter: "2026Q4"
  },
  {
    key: "Lección 9",
    text: "Lección 9",
    value: "2026-11-28",
    quarter: "2026Q4"
  },
  {
    key: "Lección 10",
    text: "Lección 10",
    value: "2026-12-05",
    quarter: "2026Q4"
  },
  {
    key: "Lección 11",
    text: "Lección 11",
    value: "2026-12-12",
    quarter: "2026Q4"
  },
  {
    key: "Lección 12",
    text: "Lección 12",
    value: "2026-12-19",
    quarter: "2026Q4"
  },
  {
    key: "Lección 13",
    text: "Lección 13",
    value: "2026-12-26",
    quarter: "2026Q4"
  }
]

export default sabaths;